import React from 'react';

const SearchIndicationSVG = () => (
  <svg
    width="61"
    height="60"
    viewBox="0 0 61 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M59.0437 51.9844L46.8216 39.7623C49.391 35.8648 50.8905 31.1993 50.8909 26.1815C50.8909 21.5435 49.6102 17.2055 47.3874 13.4973L42.173 18.7114C43.2348 20.9805 43.831 23.5107 43.831 26.1811C43.8306 35.9287 35.9292 43.8309 26.1812 43.8312C23.5108 43.8312 20.9802 43.235 18.7112 42.1732L13.4971 47.3873C17.2049 49.6105 21.5429 50.8911 26.1812 50.8911C31.2262 50.8911 35.9158 49.3757 39.8263 46.7802L52.556 59.033C53.9549 60.3789 56.1749 60.3119 57.4894 58.8829L59.1496 57.0781C60.4641 55.6492 60.4165 53.3572 59.0437 51.9844Z"
      fill="#884EA2"
    />
    <path
      d="M10.1896 33.6507C9.12779 31.382 8.53193 28.8521 8.53193 26.1817C8.53158 16.4341 16.4334 8.53193 26.1817 8.53158C28.8521 8.53158 31.382 9.12779 33.6511 10.1896L38.8652 4.97516C35.1573 2.75235 30.8197 1.47168 26.1817 1.47168C12.5345 1.47203 1.47203 12.5345 1.47168 26.1813C1.47168 30.8193 2.75199 35.1573 4.97516 38.8655L10.1896 33.6507Z"
      fill="#884EA2"
    />
    <ellipse
      cx="22.8094"
      cy="29.4315"
      rx="2.20736"
      ry="2.20736"
      fill="#DF126C"
    />
    <ellipse
      cx="28.6956"
      cy="29.4315"
      rx="2.20736"
      ry="2.20736"
      fill="#DF126C"
    />
    <ellipse
      cx="34.5819"
      cy="29.4315"
      rx="2.20736"
      ry="2.20736"
      fill="#DF126C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.7526 51.5051C39.9753 51.5051 51.5051 39.9753 51.5051 25.7526C51.5051 11.5298 39.9753 0 25.7526 0C11.5298 0 0 11.5298 0 25.7526C0 39.9753 11.5298 51.5051 25.7526 51.5051ZM25.7526 42.6757C35.099 42.6757 42.6757 35.099 42.6757 25.7526C42.6757 16.4062 35.099 8.82945 25.7526 8.82945C16.4062 8.82945 8.82945 16.4062 8.82945 25.7526C8.82945 35.099 16.4062 42.6757 25.7526 42.6757Z"
      fill="#884EA2"
    />
    <path d="M17.6587 17.6589V31.6389" stroke="#3E4968" strokeWidth="2" />
  </svg>
);

const AvatarFacilitySVG = () => (
  <svg
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18.9219" r="18" fill="#EDE4F1" />
    <path
      d="M20.8125 15.5469H18.5625V13.2969H17.4375V15.5469H15.1875V16.6719H17.4375V18.9219H18.5625V16.6719H20.8125V15.5469Z"
      fill="#884EA2"
    />
    <path
      d="M24.75 15.5469H23.625V12.1719C23.6247 11.8736 23.5061 11.5876 23.2952 11.3767C23.0843 11.1658 22.7983 11.0472 22.5 11.0469H13.5C13.2017 11.0472 12.9157 11.1658 12.7048 11.3767C12.4939 11.5876 12.3753 11.8736 12.375 12.1719V15.5469H11.25C10.9517 15.5472 10.6657 15.6658 10.4548 15.8767C10.2439 16.0876 10.1253 16.3736 10.125 16.6719V26.7969H25.875V16.6719C25.8747 16.3736 25.7561 16.0876 25.5452 15.8767C25.3343 15.6658 25.0483 15.5472 24.75 15.5469ZM16.875 25.6719V22.2969H19.125V25.6719H16.875ZM20.25 25.6719V21.7344C20.25 21.5852 20.1907 21.4421 20.0852 21.3366C19.9798 21.2311 19.8367 21.1719 19.6875 21.1719H16.3125C16.1633 21.1719 16.0202 21.2311 15.9148 21.3366C15.8093 21.4421 15.75 21.5852 15.75 21.7344V25.6719H11.25V16.6719H13.5V12.1719H22.5V16.6719H24.75V25.6719H20.25Z"
      fill="#884EA2"
    />
  </svg>
);

export { SearchIndicationSVG, AvatarFacilitySVG };
